require('../theme/fonts/icomoon/icomoon.css');
// MVK-3409 — Dashkit 2.3.0 build từ SCSS source + Bootstrap 5 (không jQuery).
require('../theme/scss/theme.scss');
require('../css/app.css');
require('../css/star-rating.css');
require('../theme/dashkit/js/bootstrap');
require('../theme/dashkit/js/tooltip');
require('../theme/dashkit/js/popover');

import { Application } from '@hotwired/stimulus';
import Routing from '../../assets/js/dependencies/jsrouting-bundle/router.min.js';
import { useBootstrap } from './composables/bootstrap';
import initStarRating from './components/StarRating';
import Cookies from 'js-cookie';
import { DEFAULT_REGION_ID, normalizeRegionId } from './utils/region-cookie';
import List from 'list.js';
import axios from 'axios';
const routes = require('../../public/js/fos_js_routes.json');
const { openModal, closeModal } = useBootstrap();

Routing.setRoutingData(routes);

// Configure Axios global settings
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Add CSRF token interceptor
axios.interceptors.request.use(function (config) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]');
  if (csrfToken) {
    config.headers['X-CSRF-Token'] = csrfToken.getAttribute('content');
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Make axios available globally
window.axios = axios;

import RegionPickerController from './stimulus/region_picker_controller';
import CinemaListController from './stimulus/cinema_list_controller';

// create root object
const root = {
  url: function(routeName, params) {
    return Routing.generate(routeName, params);
  },
  asset: function(path) {
    let baseUri = process.env.APP_CDN_URL;
    return baseUri + '/' + path;
  },
  loading: function() {
    return true;
  },
  getRegion: function() {
    const rawRegion = Cookies.get('region');
    const regionId = normalizeRegionId(rawRegion);
    if (regionId !== null) {
      return regionId;
    }
    // Cookie CÓ mặt nhưng hỏng (`null`, `undefined`, rỗng…): ghi đè ngay bằng mặc định để nó không
    // theo người dùng thêm 365 ngày nữa — với `region=null` thì mỗi ngày mang nó là một ngày ăn 403
    // toàn site. Cookie vắng mặt thì KHÔNG ghi gì, tránh đặt cookie cho khách mới. MVK-3037.
    if (typeof rawRegion !== "undefined") {
      Cookies.set('region', DEFAULT_REGION_ID, { expires: 365 });
    }
    return DEFAULT_REGION_ID;
  },
  setRegion: function(region) {
    const regionId = normalizeRegionId(region);
    // Không bao giờ ghi giá trị hỏng vào cookie — xem MVK-3037.
    if (regionId === null) {
      return;
    }
    Cookies.set('region', regionId, { expires: 365 });
  },
  getCookie: function() {
    return Cookies;
  }
};

// MVK-3407: hết Vue — hai modal chung (khu vực, rạp) là Stimulus controller nạp fragment Twig. Một Application riêng,
// KHÔNG qua `assets/bootstrap.js`: bridge đó nạp eager ux-turbo + CSS tom-select cho mọi trang, và quét
// `assets/controllers/` — controller ở đó sẽ bị đăng ký lần hai trên trang user/editor (hai lần fetch).
// MVK-3314 (CSTI): HTML server không bao giờ là template phía client; tests/Twig/NoVueTest.php giữ điều đó.
RegionPickerController.root = root;
CinemaListController.root = root;
const stimulus = Application.start();
stimulus.register('region-picker', RegionPickerController);
stimulus.register('cinema-list', CinemaListController);

function fadeInElement(element, duration = 500) {
  if (!element) {
    return;
  }

  element.hidden = false;
  element.classList.remove('d-none');
  element.style.removeProperty('display');

  if (window.getComputedStyle(element).display === 'none') {
    element.style.display = 'block';
  }

  element.style.opacity = '0';

  const startTime = performance.now();

  function step(timestamp) {
    const progress = Math.min((timestamp - startTime) / duration, 1);

    element.style.opacity = String(progress);

    if (progress < 1) {
      window.requestAnimationFrame(step);
      return;
    }

    element.style.removeProperty('opacity');
  }

  window.requestAnimationFrame(step);
}

const initialize = () => {
  const cdnBaseUri = window.cdn_base_uri || process.env.APP_CDN_URL || '';
  const ratingModalLoadingMarkup = '<div class="modal-body"> <div class="text-center"> <div class="text-muted spinner-border" role="status"> <span class="visually-hidden">Loading...</span> </div> </div> </div>';
  const ratingModalErrorMarkup = '<div class="modal-body"><div class="alert alert-warning mb-0">Có lỗi xảy ra khi tải form đánh giá. Vui lòng thử lại.</div></div>';
  let ratingModalRequestSequence = 0;

  global.Routing = Routing;
  window.Routing = Routing;
  window.List = List;
  window.Cookies = Cookies;
  window.regions = window.regions || {};

  window.generateRouteUrl = function(path, params, absolute) {
    return Routing.generate(path, params, absolute);
  };

  window.generateAssetUrl = function(path) {
    return `${cdnBaseUri}${path}`;
  };

  window.delay = function(callback, ms) {
    let timer = 0;

    return function(...args) {
      clearTimeout(timer);
      timer = window.setTimeout(() => {
        callback.apply(this, args);
      }, ms || 0);
    };
  };

  function normalizeFormElement(formElement) {
    if (!formElement) {
      return null;
    }

    if (formElement.nodeType === Node.ELEMENT_NODE) {
      return formElement;
    }

    return null;
  }

  window.clearFormErrors = function(formElement) {
    const normalizedForm = normalizeFormElement(formElement);

    if (!normalizedForm) {
      return;
    }

    normalizedForm.querySelectorAll('.mb-4').forEach(function(formGroup) {
      formGroup.querySelectorAll('.form-control').forEach(function(formControl) {
        formControl.classList.remove('is-invalid');
      });
      formGroup.querySelectorAll('.invalid-feedback').forEach(function(formError) {
        formError.remove();
      });
    });
  };

  window.displayFormErrors = function(errors, formElement) {
    const normalizedForm = normalizeFormElement(formElement);

    if (!normalizedForm) {
      return;
    }

    window.clearFormErrors(normalizedForm);

    if (!errors || !errors.fields) {
      return;
    }

    Object.keys(errors.fields).forEach(function(key) {
      const formInput = normalizedForm.querySelector('#' + key);

      if (!formInput) {
        return;
      }

      const formGroup = formInput.closest('.mb-4');
      const formError = formGroup ? formGroup.querySelector('.invalid-feedback') : null;
      const blockError = document.createElement('div');
      const icon = document.createElement('i');

      blockError.className = 'invalid-feedback';
      icon.className = 'fe fe-alert-circle';
      blockError.appendChild(icon);
      blockError.insertAdjacentHTML('beforeend', ' ' + errors.fields[key]);

      formInput.classList.add('is-invalid');

      if (formError) {
        formError.replaceWith(blockError);
        return;
      }

      formInput.insertAdjacentElement('afterend', blockError);
    });
  };

  global.generateRouteUrl = window.generateRouteUrl;
  global.generateAssetUrl = window.generateAssetUrl;

  function setModalAlertText(selector, message) {
    const alertElement = document.querySelector(selector);
    if (!alertElement) {
      return;
    }

    if (message) {
      alertElement.classList.remove('d-none');
      alertElement.textContent = message;
      return;
    }

    alertElement.classList.add('d-none');
    alertElement.textContent = '';
  }

  window.setErrorModalDescription = function(message, useHtml = false) {
    const descriptionElement = document.querySelector('#errorModal .card-body .description');
    if (!descriptionElement) {
      return;
    }

    if (useHtml) {
      descriptionElement.innerHTML = message;
      return;
    }

    descriptionElement.textContent = message;
  };

  const loginModalForm = document.getElementById('loginModalForm');
  if (loginModalForm && loginModalForm.dataset.loginFormSubmitBound !== 'true') {
    loginModalForm.dataset.loginFormSubmitBound = 'true';

    loginModalForm.addEventListener('submit', function(event) {
      event.preventDefault();

      const submitButton = loginModalForm.querySelector('.btn-submit');
      const submitButtonHtml = submitButton ? submitButton.innerHTML : null;

      if (submitButton) {
        submitButton.innerHTML = 'Đăng nhập...';
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('disabled');
      }

      axios.post(loginModalForm.action, new URLSearchParams(new FormData(loginModalForm)), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(function(response) {
        const responseText = response.data;

        if (responseText.status == 'success') {
          setModalAlertText('#userModal .alert-danger', '');
          closeModal('userModal');
          window.location.reload();
          return;
        }

        setModalAlertText('#userModal .alert-danger', responseText.message);

        if (submitButton && submitButtonHtml !== null) {
          submitButton.innerHTML = submitButtonHtml;
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('disabled');
        }
      }).catch(function() {
        setModalAlertText('#userModal .alert-danger', 'Có lỗi xảy ra, vui lòng thử lại.');

        if (submitButton && submitButtonHtml !== null) {
          submitButton.innerHTML = submitButtonHtml;
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('disabled');
        }
      });
    });
  }

  function setRatingModalContent(modalElement, html) {
    const modalContent = modalElement ? modalElement.querySelector('.modal-content') : null;
    if (!modalContent) {
      return null;
    }

    modalContent.innerHTML = html;
    return modalContent;
  }

  function isActiveRatingModalRequest(modalElement, requestId) {
    return Boolean(
      modalElement
      && modalElement.dataset.ratingRequestId === String(requestId)
      && modalElement.getAttribute('aria-hidden') !== 'true'
    );
  }

  function getRatingPointFromModalContent(modalContent, sourceUrl) {
    const fieldValue = modalContent
      ? modalContent.querySelector('#movie_rating_point')?.value
      : null;

    if (fieldValue !== null && fieldValue !== '') {
      return fieldValue;
    }

    if (!sourceUrl) {
      return undefined;
    }

    try {
      const parsedUrl = new URL(sourceUrl, window.location.origin);
      const point = parsedUrl.searchParams.get('rating');

      return point !== null && point !== '' ? point : undefined;
    } catch (error) {
      return undefined;
    }
  }

  function serializeFormState(form) {
    return new URLSearchParams(new FormData(form)).toString();
  }

  function bindDirtyWarning(form, warning, modal) {
    if (!form || form.__dirtyWarningBound) {
      return;
    }

    const initialState = serializeFormState(form);
    let isDirty = false;

    function toggleBeforeUnload(shouldWarn) {
      if (shouldWarn === isDirty) {
        return;
      }

      if (shouldWarn) {
        window.addEventListener('beforeunload', handleBeforeUnload);
      } else {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      }

      isDirty = shouldWarn;
    }

    function handleBeforeUnload(event) {
      event.preventDefault();
      event.returnValue = '';
      return '';
    }

    function syncWarning() {
      const shouldWarn = serializeFormState(form) !== initialState;

      if (warning) {
        warning.classList.toggle('d-none', !shouldWarn);
      }

      toggleBeforeUnload(shouldWarn);
    }

    form.addEventListener('input', syncWarning);
    form.addEventListener('change', syncWarning);
    form.__dirtyWarningBound = true;

    if (modal) {
      const modalVisibilityObserver = new MutationObserver(function() {
        const isVisible = modal.classList.contains('show') || window.getComputedStyle(modal).display !== 'none';

        if (isVisible) {
          return;
        }

        form.removeEventListener('input', syncWarning);
        form.removeEventListener('change', syncWarning);
        window.removeEventListener('beforeunload', handleBeforeUnload);
        delete form.__dirtyWarningBound;
        delete form.dataset.ratingFormSubmitBound;
        modalVisibilityObserver.disconnect();
      });

      modalVisibilityObserver.observe(modal, {
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-hidden']
      });
    }

    syncWarning();
  }

  window.bindRating = function(point) {
    const ratingInput = document.getElementById('movie_rating_point');
    const ratingForm = document.getElementById('movie_rating_form');
    let ratingModal = ratingForm ? ratingForm.closest('.modal') : null;
    const loginTargetInput = document.querySelector('#loginModalForm input[name=_target_path]');
    const userModalWarning = document.querySelector('#userModal .alert-warning');

    if (!ratingInput || !ratingForm) {
      return;
    }

    if (!ratingModal) {
      ratingModal = document.getElementById('ratingModal');
    }

    const ratingWidget = initStarRating(ratingInput, {
      stars: 10,
      min: 1,
      max: 10,
      step: 1
    });

    if (ratingWidget && typeof point !== 'undefined' && point !== null && point !== '') {
      ratingWidget.setValue(point);
    }

    if (ratingForm.dataset.ratingFormSubmitBound === 'true') {
      return;
    }
    ratingForm.dataset.ratingFormSubmitBound = 'true';

    ratingForm.addEventListener('submit', function(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const submitButton = form.querySelector('.btn-submit');
      const submitButtonHtml = submitButton ? submitButton.innerHTML : null;

      if (submitButton) {
        submitButton.innerHTML = 'Đang gửi...';
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('disabled');
      }

      axios.post(form.action, new URLSearchParams(new FormData(form)), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      }).then(function(response) {
        const responseText = response.data;

        if (submitButton && submitButtonHtml !== null) {
          submitButton.innerHTML = submitButtonHtml;
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('disabled');
        }

        if (responseText.status == 'success') {
          clearFormErrors(ratingForm);
          closeModal(ratingModal || 'ratingModal');

          const ratingPoint = document.getElementById('rating-point');
          const ratingVotes = document.getElementById('rating-votes');
          const ratingYours = document.getElementById('rating-yours');
          const watchButton = document.querySelector('.btn-do-movie-action[data-id="' + responseText.data.id + '"][data-action="watch"]');
          const otherRatingsButton = document.querySelector('#msgModal .btn-other-ratings');

          if (ratingPoint) {
            ratingPoint.textContent = responseText.data.rating;
          }
          if (ratingVotes) {
            ratingVotes.textContent = responseText.data.votes;
          }
          if (ratingYours) {
            ratingYours.textContent = responseText.data.yours;

            const ratingButton = ratingYours.closest('.btn');
            if (ratingButton) {
              ratingButton.classList.add('active');
            }
          }
          if (watchButton) {
            watchButton.classList.add('active');
          }
          if (otherRatingsButton) {
            otherRatingsButton.setAttribute('href', generateRouteUrl('orn_web_movie_review', { slug: responseText.data.slug }));
          }

          openModal('msgModal');
          setTimeout(function() {
            closeModal('msgModal');
          }, 5000);
        } else if (responseText.status == 'unauthorized') {
          clearFormErrors(ratingForm);
          openModal('userModal');

          if (userModalWarning) {
            userModalWarning.classList.remove('d-none');
          }
          if (typeof responseText.target_url !== 'undefined' && loginTargetInput) {
            loginTargetInput.value = responseText.target_url;
          }
        } else {
          displayFormErrors(responseText.errors, ratingForm);
        }
      }).catch(function() {
        window.setErrorModalDescription('<p class="mb-0">Có lỗi xảy ra, vui lòng thử lại.</p>', true);
        openModal('errorModal');

        if (submitButton && submitButtonHtml !== null) {
          submitButton.innerHTML = submitButtonHtml;
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('disabled');
        }
      });
    });

    bindDirtyWarning(ratingForm, document.getElementById('approval-warning'), ratingModal);
  };

  const videoModal = document.getElementById('videoModal');
  if (videoModal) {
    const modalBody = videoModal.querySelector('.modal-body');

    const resetVideoModal = function() {
      if (!modalBody) {
        return;
      }

      modalBody.innerHTML = `
        <div class="text-center">
          <div class="text-muted spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      `;
    };

    const isVideoModalTrigger = function(target) {
      return target.closest('[data-bs-toggle="modal"][data-bs-target="#videoModal"]');
    };

    document.addEventListener('click', function(event) {
      const trigger = isVideoModalTrigger(event.target);
      const videoUrl = trigger ? trigger.getAttribute('data-video-url') : null;

      if (!trigger || !videoUrl || !modalBody) {
        return;
      }

      event.preventDefault();

      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({
          event: 'virtualPageView',
          virtualUrl: trigger.getAttribute('href')
        });
      }

      modalBody.innerHTML = '<div class="js-video youtube widescreen"><iframe width="729" height="500" src="//www.youtube.com/embed/' + videoUrl + '?hd=1" frameborder="0" allowfullscreen></iframe></div>';
      openModal(videoModal);
    });

    let wasVisible = false;
    const videoModalObserver = new MutationObserver(function() {
      const isVisible = videoModal.classList.contains('show') || window.getComputedStyle(videoModal).display !== 'none';

      if (isVisible === wasVisible) {
        return;
      }

      wasVisible = isVisible;

      if (!isVisible) {
        resetVideoModal();
      }
    });

    videoModalObserver.observe(videoModal, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
  }

  const ratingModal = document.getElementById('ratingModal');
  if (ratingModal) {
    const resetRatingModal = function() {
      ratingModal.dataset.ratingRequestId = String(++ratingModalRequestSequence);
      setRatingModalContent(ratingModal, ratingModalLoadingMarkup);
    };

    document.addEventListener('click', function(event) {
      const trigger = event.target.closest('[data-bs-toggle="modal"][data-bs-target="#ratingModal"]');
      const url = trigger ? trigger.getAttribute('href') : null;

      if (!trigger || !url) {
        return;
      }

      event.preventDefault();

      const requestId = ++ratingModalRequestSequence;
      ratingModal.dataset.ratingRequestId = String(requestId);
      setRatingModalContent(ratingModal, ratingModalLoadingMarkup);
      openModal(ratingModal);

      axios.get(url, {
        responseType: 'text',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function(response) {
        return response.data;
      }).then(function(html) {
        if (!isActiveRatingModalRequest(ratingModal, requestId)) {
          return;
        }

        const modalContent = setRatingModalContent(ratingModal, html);
        if (modalContent) {
          window.bindRating(getRatingPointFromModalContent(modalContent, url));
        }
      }).catch(function() {
        if (!isActiveRatingModalRequest(ratingModal, requestId)) {
          return;
        }

        setRatingModalContent(ratingModal, ratingModalErrorMarkup);
        window.setErrorModalDescription('<p class="mb-0">Có lỗi xảy ra khi tải form đánh giá. Vui lòng thử lại.</p>', true);
        openModal('errorModal');
      });
    });

    const ratingModalObserver = new MutationObserver(function() {
      const isVisible = ratingModal.classList.contains('show') || window.getComputedStyle(ratingModal).display !== 'none';

      if (!isVisible) {
        resetRatingModal();
      }
    });

    ratingModalObserver.observe(ratingModal, {
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden']
    });
  }

  document.addEventListener('click', function(event) {
    const revealSpoilerButton = event.target.closest('.btn-reveal-spoiler');
    if (!revealSpoilerButton) {
      return;
    }

    event.preventDefault();

    const spoilAlert = revealSpoilerButton.closest('.spoil-alert');
    const reviewContent = spoilAlert ? spoilAlert.querySelector('.review-content') : null;

    revealSpoilerButton.style.display = 'none';

    if (reviewContent) {
      fadeInElement(reviewContent, 500);
    }
  });

  // MVK-3550: handler tim phim mất cùng main.js ở MVK-2311; khôi phục. Khách ẩn danh không có
  // data-token (template chỉ render token khi đăng nhập, để trang công khai không mở session) —
  // endpoint trả `login` trước khi kiểm CSRF nên vẫn mở được modal đăng nhập.
  document.addEventListener('click', function(event) {
    const movieLikeButton = event.target.closest('.btn-do-movie-like');
    if (!movieLikeButton) {
      return;
    }

    event.preventDefault();

    const wasLiked = movieLikeButton.classList.contains('liked');
    movieLikeButton.classList.toggle('liked');

    axios.post(Routing.generate('orn_web_movie_action', { action: 'like', id: movieLikeButton.dataset.id }), new URLSearchParams({
      _token: movieLikeButton.dataset.token || ''
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(function(response) {
      const data = response.data;

      if (data.msg == 'login') {
        openModal('userModal');
      }

      if (data.msg != 'success') {
        movieLikeButton.classList.toggle('liked', wasLiked);
      }
    }).catch(function() {
      movieLikeButton.classList.toggle('liked', wasLiked);
    });
  });

  document.addEventListener('click', function(event) {
    const likeButton = event.target.closest('.btn-do-like');
    if (!likeButton) {
      return;
    }

    event.preventDefault();

    if (likeButton.classList.contains('disabled')) {
      return;
    }

    const id = likeButton.dataset.id;
    const token = likeButton.dataset.token;
    const value = likeButton.dataset.value;
    const group = likeButton.closest('.btn-actions');
    const likeButtons = group ? Array.from(group.querySelectorAll('.btn-do-like')) : [likeButton];

    function restoreLikeButtons() {
      likeButtons.forEach(function(button) {
        button.classList.remove('disabled');
      });
    }

    likeButtons.forEach(function(button) {
      button.classList.add('disabled');
    });

    axios.post(Routing.generate('orn_web_rating_like', { id: id }), new URLSearchParams({
      _token: token,
      value: value
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }).then(function(response) {
      const data = response.data;

      if (data.msg == 'login') {
        restoreLikeButtons();
        openModal('userModal');
        return;
      }

      if (data.msg != 'success') {
        restoreLikeButtons();
        return;
      }

      if (value == 1) {
        likeButton.classList.add('btn-outline-success');
      } else {
        likeButton.classList.add('btn-outline-danger');
      }
      likeButton.classList.remove('btn-outline-dark');

      const likeCount = group ? group.querySelector('.like-count') : null;
      if (likeCount) {
        likeCount.textContent = (data.count > 0 ? '+' : '') + data.count;
        likeCount.classList.remove('d-none', 'text-success', 'text-danger');

        if (data.count > 0) {
          likeCount.classList.add('text-success');
        }
        if (data.count < 0) {
          likeCount.classList.add('text-danger');
        }
      }
    }).catch(function() {
      restoreLikeButtons();
    });
  });

  // Second-level (nested) dropdowns in the main nav. Bootstrap 4 has no native
  // multilevel dropdown support, so toggle the fly-out menu manually.
  function getSubmenu(toggle) {
    const submenu = toggle.nextElementSibling;
    return submenu && submenu.classList.contains('dropdown-menu') ? submenu : null;
  }

  function closeSubmenu(toggle) {
    const submenu = getSubmenu(toggle);

    toggle.setAttribute('aria-expanded', 'false');
    if (submenu) {
      submenu.classList.remove('show');
    }
  }

  // Bind directly on each submenu toggle. Stopping propagation here — before the
  // click reaches the document — prevents Bootstrap's clearMenus handler (bound
  // on document) from closing the parent dropdown.
  document.querySelectorAll('.js-submenu-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      const submenu = getSubmenu(toggle);
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      const parentMenu = toggle.closest('.dropdown-menu');

      // Collapse sibling submenus so only one stays open at a time.
      if (parentMenu) {
        parentMenu.querySelectorAll('.js-submenu-toggle').forEach(function(siblingToggle) {
          if (siblingToggle !== toggle) {
            closeSubmenu(siblingToggle);
          }
        });
      }

      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (submenu) {
        submenu.classList.toggle('show', !isOpen);
      }
    });
  });

  // Reset submenu state whenever the parent dropdown is closed by Bootstrap.
  // BS5 phát `hidden.bs.dropdown` (DOM native, bubble) trên nút toggle.
  document.addEventListener('hidden.bs.dropdown', function(event) {
    const dropdown = event.target.closest('.dropdown');
    if (dropdown) dropdown.querySelectorAll('.js-submenu-toggle').forEach(closeSubmenu);
  });
};

initialize();
